// eslint-disable-next-line no-shadow
export enum OAuthProvider {
  GOOGLE = "google",
  META = "meta",
  LINKEDIN = "linkedin",
}

// eslint-disable-next-line no-shadow
export enum OAuthStep {
  Start = "start",
  Confirm = "confirm",
  VerifyEmail = "verify_email",
}
